import { useState } from "react";
import { SectionLabel, Reveal, WEBINAR_DURATION } from "./shared";
import { AccordionItem } from "./Accordion";

const MODULES = [
  {
    title: "CLARIFY WHAT YOU'RE ACTUALLY WORKING WITH",
    body: "General education on VA-backed financing basics — eligibility and entitlement questions, what documentation a lender reviews, and which unanswered question is really blocking your decision. Educational only; nothing here confirms your individual eligibility.",
  },
  {
    title: "SEE THE WHOLE TRANSACTION, NOT ONE NUMBER",
    body: "How property choice, an existing home or existing obligations, cash-to-close inputs, and financing structure interact as one connected deal instead of a series of disconnected quotes.",
  },
  {
    title: "THE REMAINING-ENTITLEMENT AND MOVE-UP CONVERSATION",
    body: "What generally changes when a household has used VA-backed financing before, already owns a home, or is planning a move-up purchase — and which questions to ask before assuming the door is closed.",
  },
  {
    title: "WHERE BUYERS GET DERAILED",
    body: "Common misunderstandings that cost buyers time — comparing quotes built on different assumptions, retelling the story to five people, or walking away from a workable file too early because the structure was never examined.",
  },
  {
    title: "GUIDE: YOUR RESPONSIBLE NEXT STEP",
    body: "The Prepare / Apply / Review decision path, explained live, so you leave knowing which of the three is actually right for you right now — including \u201Cprepare and wait.\u201D",
  },
];

export default function Curriculum() {
  const [open, setOpen] = useState(0);
  return (
    <section className="py-24 lg:py-36 px-6 lg:px-10" data-testid="curriculum-section">
      <div className="max-w-5xl mx-auto">
        <Reveal>
          <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4 mb-12">
            <div>
              <SectionLabel n="004" text="THE CURRICULUM" />
              <h2 className="font-black uppercase text-3xl md:text-4xl tracking-tight">
                GET A SNEAK PEEK INTO THE MASTERCLASS
              </h2>
            </div>
            <p className="font-mono-strict text-[11px] tracking-[0.25em] text-white/40 shrink-0">
              5 MODULES · {WEBINAR_DURATION}
            </p>
          </div>
        </Reveal>
        <Reveal delay={0.1}>
          <div className="border-t border-[#404653]/40">
            {MODULES.map((m, i) => (
              <AccordionItem
                key={i}
                num={String(i + 1).padStart(2, "0")}
                title={m.title}
                body={m.body}
                open={open === i}
                onToggle={() => setOpen(open === i ? -1 : i)}
                testId={`curriculum-item-${i + 1}`}
              />
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
}
